import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '../../../Icon';


const styles = theme => ({
  root: {
    padding:`0 ${theme.margins.xs}px`,
    transition:'width .5s, border-bottom 2s',
  },
  input: {
    ...theme.typography.body1,
    lineHeight:1,
    fontWeight: 400,
    padding: `${theme.margins.xs}px 0`,
  },
  select: {
  },
  disabled: {},
  focused: {},
  error: {},
  underline: {
    '&:before':{
        borderBottom: `1px solid ${theme.palette.lightGrey}`
     },
    '&:hover:not($disabled):not($focused):not($error):before':{
        borderBottomColor: theme.palette.mediumGrey,
     },
    '&:after': {
        borderBottomColor: theme.palette.deepGrey,
        //borderBottom: `1px solid ${theme.palette.deepGrey}`
     }
  },
  input_auto: {
    width:'100%',
    alignSelf:'flex-end',
  },
  small_input: {
    width:42,
    alignSelf:'flex-end',
    cursor:'pointer',
    background:'white'
  },
  icon_class: {
    cursor:'pointer',
  }
});


const SearchInput = ({
  classes: {
    root,
    input,
    underline,
    small_input,
    input_auto,
    icon_class
  },
  disableUnderline,
  iconComponent,
  className,
  input_class,
  value,
  set_ref,
  grow,
  ...other
}) => {

  return (
    <Input
       classes = {{
           root: `${root}`,
           input: `${input} ${(input_class||"")}`,
           underline
       }}
       className = {className || ""}
       value = {value}
       endAdornment = {
         <Icon
            type = "icon-zoom"
            size ='sm'
            className = {icon_class}
            onClick = {grow}
        />
       }

       onChange = {other.onChange}

    />
  )
}

SearchInput.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    input: PropTypes.string.isRequired,
  }),
  iconComponent: React.isValidElement,
  className: PropTypes.string
};

SearchInput.defaultProps = {
  iconComponent: null,
  disableUnderline: true
}

export default React.memo(withStyles(styles)(SearchInput));
